/**
 * Fixed copy of a news article page: the heading of its "Latest News" list, per language.
 * Read only by `components/NewsEvents/News/NewsArticle.tsx`.
 */
import { LanguageContent } from "@ryerson/frontend.common";
import { StaticNewsContent } from "../types";

/** The "Latest News" heading over the three newest articles beside an article. */
export const StaticContent: LanguageContent<StaticNewsContent> = {
	en: {
		latestHeading: "Latest News",
	},
	fr: {
		latestHeading: "Dernières nouvelles",
	},
	es: {
		latestHeading: "Últimas noticias",
	},
};
